import Api, {
  baseURL,
  requestOptionsGET,
  requestOptionsPOST,
  requestOptionsPOSTwithFormData,
  requestOptionsDELETE,
  requestOptionsPUT,
  requestOptionsPUTWithBody
} from '../api';
import newFetch from '../utils/newFetch';

const state = {
  shipments: [],
  manegementShipments: [],
  paginate: {
    pageNumber: 1,
    pageSize: 10,
    totalRecords: 0,
    totalPages: 0
  },
  filters: {
    CreatedAt: null,
    DirectDelivererName: null,
    StatusId: null,
    ResponsibleUserName: null
  },
  filtersManegement: {
    DeliveryForecastDateStart: null,
    DeliveryForecastDateEnd: null,
    DownloadedReceipt: null,
    PurgedReceipt: null,
    StateId: null,
    CityId: null,
    AuthorizationDateStart: null,
    AuthorizationDateEnd: null,
    CompletionDateStart: null,
    CompletionDateEnd: null,
    HasReceipt: null,
    IsReceiptValid: null,
    IsTransferred: null,
    TranshipmentId: null,
    CteNumber: [],
    SenderName: null,
    SenderId: null,
    RecipientName: null,
    NfeNumber: [],
    BoardingNumber: [],
    BoardingId: null,
    NumberInvoiceId: null,
    DirectDelivererId: null,
    Status: []
  }
};

const getters = {
  getShipments: (state) => state.shipments,
  getManegementShipments: (state) => state.manegementShipments,
  getFiltersObject: (state) => state.filtersManegement,
  getFilters: ({ paginate, filters }) => {
    return (
      `?PageSize=${paginate.pageSize}&PageNumber=${paginate.pageNumber}` +
      (filters.CreatedAt ? '&CreatedAt=' + filters.CreatedAt : '') +
      (filters.DirectDelivererName ? '&DirectDelivererName=' + filters.DirectDelivererName : '') +
      (filters.StatusId ? '&StatusId=' + filters.StatusId : '') +
      (filters.ResponsibleUserName ? '&ResponsibleUserName=' + filters.ResponsibleUserName : '')
    );
  },
  getManegementFilters: ({ paginate, filtersManegement }) => {
    let status = '';
    if (filtersManegement.Status.length > 0) {
      filtersManegement.Status.forEach((element) => {
        status = status + '&StatusIds=' + element;
      });
    }
    let cteNumbers = '';
    if (filtersManegement.CteNumber.length > 0) {
      filtersManegement.CteNumber.forEach((element) => {
        cteNumbers = cteNumbers + '&CteNumber=' + element;
      });
    }
    let boardingNumbers = '';
    if (filtersManegement.BoardingNumber.length > 0) {
      filtersManegement.BoardingNumber.forEach((element) => {
        boardingNumbers = boardingNumbers + '&BoardingNumber=' + element;
      });
    }
    let nfeNumbers = '';
    if (filtersManegement.NfeNumber.length > 0) {
      filtersManegement.NfeNumber.forEach((element) => {
        nfeNumbers = nfeNumbers + '&NfeNumber=' + element;
      });
    }
    return (
      `?PageSize=${paginate.pageSize}&PageNumber=${paginate.pageNumber}` +
      (filtersManegement.StateId ? '&StateId=' + filtersManegement.StateId : '') +
      (filtersManegement.CityId ? '&CityId=' + filtersManegement.CityId : '') +
      (filtersManegement.AuthorizationDateStart
        ? '&AuthorizationDateStart=' + filtersManegement.AuthorizationDateStart
        : '') +
      (filtersManegement.AuthorizationDateEnd
        ? '&AuthorizationDateEnd=' + filtersManegement.AuthorizationDateEnd
        : '') +
      (filtersManegement.DeliveryForecastDateStart
        ? '&DeliveryForecastDateStart=' + filtersManegement.DeliveryForecastDateStart
        : '') +
      (filtersManegement.DeliveryForecastDateEnd
        ? '&DeliveryForecastDateEnd=' + filtersManegement.DeliveryForecastDateEnd
        : '') +
      (filtersManegement.CompletionDateStart ? '&CompletionDateStart=' + filtersManegement.CompletionDateStart : '') +
      (filtersManegement.CompletionDateEnd ? '&CompletionDateEnd=' + filtersManegement.CompletionDateEnd : '') +
      (filtersManegement.HasReceipt !== null ? '&HasReceipt=' + filtersManegement.HasReceipt : '') +
      (filtersManegement.IsReceiptValid !== null ? '&ReceiptIsValid=' + filtersManegement.IsReceiptValid : '') +
      (filtersManegement.IsTransferred !== null ? '&Transferred=' + filtersManegement.IsTransferred : '') +
      (filtersManegement.DownloadedReceipt !== null
        ? '&DownloadedReceipt=' + filtersManegement.DownloadedReceipt
        : '') +
      (filtersManegement.PurgedReceipt !== null ? '&PurgedReceipt=' + filtersManegement.PurgedReceipt : '') +
      (filtersManegement.TranshipmentId ? '&TranshipmentId=' + filtersManegement.TranshipmentId : '') +
      (filtersManegement.SenderName ? '&SenderName=' + filtersManegement.SenderName : '') +
      (filtersManegement.SenderId ? '&SenderId=' + filtersManegement.SenderId : '') +
      (filtersManegement.RecipientName ? '&RecipientName=' + filtersManegement.RecipientName : '') +
      (filtersManegement.BoardingId ? '&BoardingId=' + filtersManegement.BoardingId : '') +
      (filtersManegement.NumberInvoiceId ? '&NumberInvoiceId=' + filtersManegement.NumberInvoiceId : '') +
      (filtersManegement.DirectDelivererId ? '&DirectDelivererId=' + filtersManegement.DirectDelivererId : '') +
      status +
      cteNumbers +
      boardingNumbers +
      nfeNumbers
    );
  }
};

const mutations = {
  setShipments(state, payload) {
    state.shipments = payload;
  },
  setManegementShipments(state, payload) {
    state.manegementShipments = payload;
  },
  setItemPerPage(state, payload) {
    state.paginate.pageSize = payload;
  },
  setPageNumber(state, payload) {
    state.paginate.pageNumber = payload;
  },
  setTotalPages(state, payload) {
    state.paginate.totalPages = payload;
  },
  setTotalRecords(state, payload) {
    state.paginate.totalRecords = payload;
  },
  setFilterCreatedAt(state, payload) {
    state.filters.CreatedAt = payload;
  },
  setFilterDirectDelivererName(state, payload) {
    state.filters.DirectDelivererName = payload;
  },
  setFilterStatusId(state, payload) {
    state.filters.StatusId = payload;
  },
  setFilterResponsibleUserName(state, payload) {
    state.filters.ResponsibleUserName = payload;
  },
  setFiltersManegementStateId(state, payload) {
    state.filtersManegement.StateId = payload;
  },
  setFiltersManegementCityId(state, payload) {
    state.filtersManegement.CityId = payload;
  },
  setFiltersManegementHasReceipt(state, payload) {
    state.filtersManegement.HasReceipt = payload;
  },
  setFiltersManegementIsReceiptValid(state, payload) {
    state.filtersManegement.IsReceiptValid = payload;
  },
  setFiltersManegementTranshipmentId(state, payload) {
    state.filtersManegement.TranshipmentId = payload;
  },
  setFiltersManegementIsTransferred(state, payload) {
    state.filtersManegement.IsTransferred = payload;
  },
  setFiltersManegementAuthorizationDateStart(state, payload) {
    state.filtersManegement.AuthorizationDateStart = payload;
  },
  setFiltersManegementAuthorizationDateEnd(state, payload) {
    state.filtersManegement.AuthorizationDateEnd = payload;
  },
  setFiltersManegementCompletionDateStart(state, payload) {
    state.filtersManegement.CompletionDateStart = payload;
  },
  setFiltersManegementDeliveryForecastDateStart(state, payload) {
    state.filtersManegement.DeliveryForecastDateStart = payload;
  },
  setFiltersManegementDeliveryForecastDateEnd(state, payload) {
    state.filtersManegement.DeliveryForecastDateEnd = payload;
  },
  setFiltersManegementCompletionDateEnd(state, payload) {
    state.filtersManegement.CompletionDateEnd = payload;
  },
  setFiltersManegementCteNumber(state, payload) {
    state.filtersManegement.CteNumber = payload;
  },
  setFiltersManegementDownloadedReceipt(state, payload) {
    state.filtersManegement.DownloadedReceipt = payload;
  },
  setFiltersManegementPurgedReceipt(state, payload) {
    state.filtersManegement.PurgedReceipt = payload;
  },
  setFiltersManegementSenderName(state, payload) {
    state.filtersManegement.SenderName = payload;
  },
  setFiltersManegementSenderId(state, payload) {
    state.filtersManegement.SenderId = payload;
  },
  setFiltersManegementRecipientName(state, payload) {
    state.filtersManegement.RecipientName = payload;
  },
  setFiltersManegementNfeNumber(state, payload) {
    state.filtersManegement.NfeNumber = payload;
  },
  setFiltersManegementBoardingNumber(state, payload) {
    state.filtersManegement.BoardingNumber = payload;
  },
  setFiltersManegementBoardingId(state, payload) {
    state.filtersManegement.BoardingId = payload;
  },
  setFiltersManegementNumberInvoiceId(state, payload) {
    state.filtersManegement.NumberInvoiceId = payload;
  },
  setFiltersManegementDirectDelivererId(state, payload) {
    state.filtersManegement.DirectDelivererId = payload;
  },
  setFiltersManegementStatus(state, payload) {
    state.filtersManegement.Status = payload;
  },
  resetManegementFilters(state) {
    state.filtersManegement = {
      StateId: null,
      CityId: null,
      AuthorizationDateStart: null,
      AuthorizationDateEnd: null,
      CompletionDateStart: null,
      CompletionDateEnd: null,
      HasReceipt: null,
      IsReceiptValid: null,
      TranshipmentId: null,
      CteNumber: [],
      SenderName: null,
      RecipientName: null,
      NfeNumber: [],
      BoardingNumber: [],
      BoardingId: null,
      NumberInvoiceId: null,
      DirectDelivererId: null,
      Status: []
    };
  }
};

const actions = {
  fetchShipment(context) {
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL + Api.getShipment + context.getters.getFilters,
        requestOptionsGET(localStorage.getItem('accessToken'))
      )
        .then(({ data, totalPages, totalRecords }) => {
          context.commit('setShipments', data);

          context.commit('setTotalPages', totalPages);
          context.commit('setTotalRecords', totalRecords);
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  changeStatus(_, params = {}) {
    params.boardingFilterDto = _.getters.getFiltersObject;

    if (params.boardingFilterDto.NfeNumber.length) {
      params.boardingFilterDto.NfeNumber = params.boardingFilterDto.NfeNumber.map((nfeNumber) => {
        const isString = typeof nfeNumber === 'string';
        return isString ? Number(nfeNumber.trim()) : nfeNumber;
      });
    }
    if (params.boardingFilterDto.CteNumber.length) {
      params.boardingFilterDto.CteNumber = params.boardingFilterDto.CteNumber.map((cteNumber) => {
        const isString = typeof cteNumber === 'string';
        return isString ? Number(cteNumber.trim()) : cteNumber;
      });
    }
    if (params.boardingFilterDto.BoardingNumber.length) {
      params.boardingFilterDto.BoardingNumber = params.boardingFilterDto.BoardingNumber.map((boardingNumber) => {
        const isString = typeof boardingNumber === 'string';
        return isString ? Number(boardingNumber.trim()) : boardingNumber;
      });
    }

    return new Promise((resolve, reject) => {
      newFetch(
        baseURL + Api.changeStatusManagerBKO,
        requestOptionsPUTWithBody(localStorage.getItem('accessToken'), params)
      )
        .then((data) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  fetchManegementShipments(context) {
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL + Api.getManegementShipments + context.getters.getManegementFilters,
        requestOptionsGET(localStorage.getItem('accessToken'))
      )
        .then(({ data, totalPages, totalRecords }) => {
          context.commit('setManegementShipments', data);

          context.commit('setTotalPages', totalPages);
          context.commit('setTotalRecords', totalRecords);
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  fetchManegementShipmentsCargoByID(context, id) {
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL + Api.getManegementShipmentsCargos + id + context.getters.getManegementFilters,
        requestOptionsGET(localStorage.getItem('accessToken'))
      )
        .then((data) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  fetchManegementShipmentsStopsByID(context, id) {
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL + Api.getManegementShipmentsStops + id + context.getters.getManegementFilters,
        requestOptionsGET(localStorage.getItem('accessToken'))
      )
        .then((data) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  fetchManegementShipmentsDeliveriesByID(context, id) {
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL + Api.getManegementShipmentsDeliveries + id + context.getters.getManegementFilters,
        requestOptionsGET(localStorage.getItem('accessToken'))
      )
        .then((data) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  fetchManegementShipmentsNFEByID(context, id) {
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL + Api.getManegementShipmentsNFE + id + context.getters.getManegementFilters,
        requestOptionsGET(localStorage.getItem('accessToken'))
      )
        .then((data) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  fetchFastManegementShipmentsNFEByID(context, id) {
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL + Api.getFastManegementShipmentsNFE + context.getters.getManegementFilters + '&boardingId=' + id,
        requestOptionsGET(localStorage.getItem('accessToken'))
      )
        .then((data) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  fetchShipmentByID(context, id) {
    return new Promise((resolve, reject) => {
      newFetch(baseURL + Api.getShipment + id, requestOptionsGET(localStorage.getItem('accessToken')))
        .then((data) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  fetchStatusShipment() {
    return new Promise((resolve, reject) => {
      newFetch(baseURL + Api.getStatusShipment, requestOptionsGET(localStorage.getItem('accessToken')))
        .then((data) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  createShipment(_, body) {
    return new Promise((resolve, reject) => {
      newFetch(baseURL + Api.getShipment, requestOptionsPOSTwithFormData(localStorage.getItem('accessToken'), body))
        .then((data) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  createSheetPackages(_, body) {
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL + Api.getSheetPackages,
        requestOptionsPOSTwithFormData(localStorage.getItem('accessToken'), body)
      )
        .then((data) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  createSheetPackagesNfe(_, body = {}) {
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL + Api.getSheetPackagesNfe + body.id,
        requestOptionsPOSTwithFormData(localStorage.getItem('accessToken'), body.form)
      )
        .then((data) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  approveShipmentSheet(_, body) {
    const { id, advanceAmount, forecastPayment: paymentForecast, additionalsDto: aditionals } = body;
    const additionalsIds = aditionals.map((item) => item.id);
    const financialData = {
      advanceAmount: advanceAmount ? advanceAmount : null,
      additionals: {
        id: additionalsIds
      },
      paymentForecast
    };

    return new Promise((resolve, reject) => {
      newFetch(
        baseURL + Api.approveSheet + id,
        requestOptionsPUTWithBody(localStorage.getItem('accessToken'), financialData)
      )
        .then((data) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  discartShipmentSheet(_, body) {
    return new Promise((resolve, reject) => {
      const { id } = body;
      newFetch(baseURL + Api.discartSheet + id, requestOptionsPUT(localStorage.getItem('accessToken')))
        .then((data) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  toogleShipment(_, prop) {
    return new Promise((resolve, reject) => {
      newFetch(baseURL + Api.getShipment + prop.type + prop.id, requestOptionsPUT(localStorage.getItem('accessToken')))
        .then((data) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  fetchEditShipment(_, body = {}) {
    return new Promise((resolve, reject) => {
      newFetch(baseURL + Api.editShipment, requestOptionsPUTWithBody(localStorage.getItem('accessToken'), body))
        .then((data) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  sendtransferHierarchy(_, body = {}) {
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL + Api.transferHierarchy,
        requestOptionsPUTWithBody(localStorage.getItem('accessToken'), { ...body })
      )
        .then((data) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  getReceiptsByHierarchies(_, body) {
    body.boardingFilterDto = _.getters.getFiltersObject;

    if (body.boardingFilterDto.NfeNumber.length) {
      body.boardingFilterDto.NfeNumber = body.boardingFilterDto.NfeNumber.map((nfeNumber) => {
        const isString = typeof nfeNumber === 'string';
        return isString ? Number(nfeNumber.trim()) : nfeNumber;
      });
    }
    if (body.boardingFilterDto.CteNumber.length) {
      body.boardingFilterDto.CteNumber = body.boardingFilterDto.CteNumber.map((cteNumber) => {
        const isString = typeof cteNumber === 'string';
        return isString ? Number(cteNumber.trim()) : cteNumber;
      });
    }
    if (body.boardingFilterDto.BoardingNumber.length) {
      body.boardingFilterDto.BoardingNumber = body.boardingFilterDto.BoardingNumber.map((boardingNumber) => {
        const isString = typeof boardingNumber === 'string';
        return isString ? Number(boardingNumber.trim()) : boardingNumber;
      });
    }
    return new Promise((resolve, reject) => {
      newFetch(baseURL + Api.getReceiptsByHierarchies, requestOptionsPOST(localStorage.getItem('accessToken'), body))
        .then((data) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  changeCompletionDate(_, body) {
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL + Api.changeCompletionDate + '?nfeId=' + body.nfeId + '&completionDate=' + body.completionDate,
        requestOptionsPUTWithBody(localStorage.getItem('accessToken'), body)
      )
        .then((data) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },

  getShipmentsManagementCtesOnTime(_, params) {
    const { pageNumber, pageSize } = params;
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL + Api.getShipmentsManagementCtesOnTime + `?PageNumber=${pageNumber}&PageSize=${pageSize}`,
        requestOptionsGET(localStorage.getItem('accessToken'))
      )
        .then((data) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  getShipmentsManagementCtesCriticalDay(_, params) {
    const { pageNumber, pageSize } = params;
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL + Api.getShipmentsManagementCtesCriticalDay + `?PageNumber=${pageNumber}&PageSize=${pageSize}`,
        requestOptionsGET(localStorage.getItem('accessToken'))
      )
        .then((data) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  getShipmentsManagementCtesLate(_, params) {
    const { pageNumber, pageSize } = params;
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL + Api.getShipmentsManagementCtesLate + `?PageNumber=${pageNumber}&PageSize=${pageSize}`,
        requestOptionsGET(localStorage.getItem('accessToken'))
      )
        .then((data) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  getTranshipmentsManagementCtesOnTime(_, params) {
    const { pageNumber, pageSize } = params;
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL + Api.getTranshipmentsManagementCtesOnTime + `?PageNumber=${pageNumber}&PageSize=${pageSize}`,
        requestOptionsGET(localStorage.getItem('accessToken'))
      )
        .then((data) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  getTranshipmentsManagementCtesCriticalDay(_, params) {
    const { pageNumber, pageSize } = params;
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL + Api.getTranshipmentsManagementCtesCriticalDay + `?PageNumber=${pageNumber}&PageSize=${pageSize}`,
        requestOptionsGET(localStorage.getItem('accessToken'))
      )
        .then((data) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  getTranshipmentsManagementCtesLate(_, params) {
    const { pageNumber, pageSize } = params;
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL + Api.getTranshipmentsManagementCtesLate + `?PageNumber=${pageNumber}&PageSize=${pageSize}`,
        requestOptionsGET(localStorage.getItem('accessToken'))
      )
        .then((data) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  deleteShipment(_, id) {
    return new Promise((resolve, reject) => {
      newFetch(baseURL + Api.deleteShipment + `/?id=${id}`, requestOptionsDELETE(localStorage.getItem('accessToken')))
        .then((data) => {
          resolve(data);
          return data;
        })
        .catch((err) => {
          reject(err);
          return err;
        });
    });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
